import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/authentication/Register')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('views/pages/authentication/authentication/ResetPassword')));
const AuthGeneratePassword = Loadable(lazy(() => import('views/pages/authentication/authentication/GeneratePassword')));

import PublicRoute from 'PublicRoute';

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/login',
      element: (
        <PublicRoute>
          <AuthLogin />
        </PublicRoute>
      )
    },
    {
      path: '/register',
      element: (
        <PublicRoute>
          <AuthRegister />
        </PublicRoute>
      )
    },
    {
      path: '/verify-account',
      element: (
        <PublicRoute>
          <AuthGeneratePassword />
        </PublicRoute>
      )
    },
    {
      path: '/forgot-password',
      element: (
        <PublicRoute>
          <AuthForgotPassword />
        </PublicRoute>
      )
    },
    {
      path: '/reset-password',
      element: (
        <PublicRoute>
          <AuthResetPassword />
        </PublicRoute>
      )
    }
  ]
};

export default AuthenticationRoutes;
